// The guest list of a wedding: everyone who shared a video, by the name they
// typed at the entry dialog (`videos.userName`). A guest who sent five clips,
// or typed "jose" once and "José" the next time, is one line.

const collator = new Intl.Collator('es', { sensitivity: 'base' })

const tidy = (name) => String(name ?? '').trim().replace(/\s+/g, ' ')

// Case- and accent-blind identity for deduplication. Ñ survives: "Nuñez" and
// "Nunez" are different surnames to a Spanish reader.
const identity = (name) => name
  .toLowerCase()
  .normalize('NFD')
  .replace(/ñ/g, 'ñ')
  .replace(/[̀-ͯ]/g, '')

/**
 * @param {Array<{userName?: ?string}>} videos
 * @returns {{names: string[], unnamed: number}} Names in Spanish order, each
 *   in the spelling it first arrived with; `unnamed` counts videos without one.
 */
export function participantNames(videos) {
  const byIdentity = new Map()
  let unnamed = 0
  for (const video of videos) {
    const name = tidy(video?.userName)
    if (!name) { unnamed += 1; continue }
    const key = identity(name)
    if (!byIdentity.has(key)) byIdentity.set(key, name)
  }
  const names = [...byIdentity.values()].sort(collator.compare)
  return { names, unnamed }
}
